export interface UserState {
  users: User[] | null;
}

export interface User {
  id: string;
  name: string;
  firstName: string;
  lastName: string;
  email?: string;
  phoneNumber?: string;
  clientName: string;
  groupName: string;
  role: UserRole;
  systemPermissions: string[];
  validPeriod: {
    from: Date;
    to: Date;
  };
  lastLogin: Date | null;
  createdAt?: Date;
  createdBy?: string;
  invalid?: boolean;
}

export enum UserRole {
  Admin = "system_administrator",
  GroupAdmin = "group_administrator",
  User = "user",
}
